import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { Result } from 'antd';
import { useAuth } from '../auth/AuthContext';

export const Can = ({ permission, children, fallback = null }: { permission: string; children: ReactNode; fallback?: ReactNode }) => {
  const { hasPermission } = useAuth();
  return hasPermission(permission) ? children : fallback;
};

export const ProtectedRoute = ({ children }: { children: ReactNode }) => {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" replace />;
};

export const PermissionRoute = ({ permission, children }: { permission: string; children: ReactNode }) => {
  const { hasPermission } = useAuth();
  return hasPermission(permission) ? children : <Result status="403" title="Access denied" subTitle="Your role does not include permission for this page." />;
};
